<ng-content></ng-content>
<button
  *ngIf="displayCopyButton"
  type="button"
  class="btn btn-xs btn-inline-icon"
  (click)="copy()"
  title="{{ 'shared.terms.copy' | translate }}"
>
  <i class="fa-light fa-copy fa-fw"></i>
</button>
